import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './BestSellers.css';
import whiteLogo from '../assets/Isologo/Isologo_ChefMargaro_FondoPositivo.png';
import { API_V1, getImageUrl, fetchApi } from '../config/api';
import { useCart } from '../context/CartContext';
import { refAmount } from '../utils/money';

const BEST_SELLERS_COUNT = 2;

// Normaliza un combo del endpoint /combos para usarlo en las tarjetas de best sellers
const normalizeCombo = (c) => ({
  id: c.id ?? c.combo_id,
  name: c.name ?? 'Combo',
  // Priorizar image_url que viene del backend para las imágenes de combos
  image: getImageUrl(c.image_url ?? c.thumbnail ?? c.thumbnail_url ?? c.image),
  price: refAmount(c.price_eur),
  createdAt: c.created_at ?? c.createdAt ?? null,
});

const BestSellers = () => {
  const { addToCart } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setError(null);
        const params = new URLSearchParams();
        params.set('per_page', String(BEST_SELLERS_COUNT));
        params.set('is_active', '1');
        const res = await fetchApi(`${API_V1}/combos?${params.toString()}`);
        if (!res.ok) throw new Error('Error al cargar combos');
        const data = await res.json();
        const list = data.data ?? data;
        const raw = Array.isArray(list) ? list : list?.data ?? [];
        // Normalize and sort by newest (descending by createdAt)
        const normalized = raw.map(normalizeCombo);
        normalized.sort((a, b) => {
          const aTime = a.createdAt ? new Date(a.createdAt).getTime() : 0;
          const bTime = b.createdAt ? new Date(b.createdAt).getTime() : 0;
          return bTime - aTime;
        });
        setProducts(normalized.slice(0, BEST_SELLERS_COUNT));
      } catch (err) {
        setError(err.message);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  const handleAddToCart = (e, product) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      quantity: 1,
      image: product.image,
    });
  };

  return (
    <section className="best-sellers">
      <div className="container">
        <div className="best-sellers-header">
          <div className="best-sellers-title-section">
            <h2 className="section-title">MÁS NUEVOS!</h2>
            <p className="section-subtitle">¡Prueba nuestros platos más nuevos!</p>
          </div>
        </div>
        <div className="best-sellers-content">
          <div className="best-sellers-background">
            <img 
              src="https://images.pexels.com/photos/4161150/pexels-photo-4161150.jpeg?_gl=1*14vllji*_ga*MjAyMTI0OTYwOS4xNzY4OTI3NjE5*_ga_8JE65Q40S6*czE3NzEwMDQwMDMkbzUkZzEkdDE3NzEwMDQwNDEkajIyJGwwJGgw" 
              alt="Background" 
              className="best-sellers-bg-image"
            />
            <div className="best-sellers-overlay"></div>
          </div>
          <div className="best-sellers-column best-sellers-logo-column">
            <img src={whiteLogo} alt="Logo" className="best-sellers-logo-image" />
          </div>
          <div className="best-sellers-column best-sellers-products-column">
            {error && (
              <p className="best-sellers-error">No se pudieron cargar los combos.</p>
            )}
            {loading && (
              <p className="best-sellers-loading">Cargando...</p>
            )}
            {!loading && !error && products.length > 0 && (
              <div className="best-sellers-grid">
                {products.map((product) => (
                  <Link
                    key={product.id}
                    to={`/combo/${product.id}`}
                    className="best-seller-card"
                  >
                    <div className="best-seller-image">
                      {product.image ? (
                        <img src={product.image} alt={product.name} onError={(e) => { e.target.style.display = 'none'; }} />
                      ) : (
                        <div className="best-seller-image-placeholder" aria-hidden />
                      )}
                    </div>
                    <div className="best-seller-content">
                      <span className="best-seller-ref">Ref. {product.price}</span>
                      <h3 className="best-seller-name">{product.name}</h3>
                      <button
                        type="button"
                        className="add-to-cart-btn"
                        onClick={(e) => handleAddToCart(e, product)}
                      >
                        AGREGAR
                      </button>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestSellers;

